import React from 'react';
import ReadingBlock from './ReadingBlock';
import WritingPrompt from './WritingPrompt';

export default function QuestionRenderer({ question, answer, onAnswer, shuffledOptions }) {
  if (question.type === 'reading_comprehension') {
    return (
      <ReadingBlock
        text={question.text}
        questions={question.questions}
        answers={answer || {}}
        onAnswer={onAnswer}
      />
    );
  }
  
  if (question.type === 'writing_prompt') {
    return (
      <WritingPrompt
        question={question}
        answer={answer}
        onAnswer={onAnswer}
      />
    );
  }
  
  if (question.type === 'multiple_choice') {
    return (
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
        {question.imageUrl && (
          <div className="mb-4 flex justify-center">
            <img 
              src={question.imageUrl} 
              alt="Ilustracja pytania" 
              className="max-w-md w-full rounded-lg shadow-md"
            />
          </div>
        )}
        <p className="font-medium text-lg text-gray-900 mb-4">{question.question}</p>
        <div className="space-y-3">
          {shuffledOptions.map((option, index) => (
            <label
              key={index}
              className="flex items-center p-4 rounded-lg border border-gray-300 hover:bg-blue-50 cursor-pointer transition-colors"
            >
              <input
                type="radio"
                name={question.id}
                value={option}
                checked={answer === option}
                onChange={(e) => onAnswer(question.id, e.target.value)}
                className="mr-3 h-5 w-5 text-blue-600"
              />
              <span className="text-gray-700 text-base">{option}</span>
            </label>
          ))}
        </div>
      </div>
    );
  }
  
  if (question.type === 'error_correction') {
    return (
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
        <p className="font-medium text-lg text-gray-900 mb-2">{question.question}</p>
        <div className="bg-gray-50 p-4 rounded-lg mb-4 border border-gray-200">
          <p className="text-gray-800 font-mono">{question.sentence}</p>
        </div>
        <input
          type="text"
          value={answer || ''}
          onChange={(e) => onAnswer(question.id, e.target.value)}
          placeholder="Wpisz poprawną formę"
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>
    );
  }
  
  if (question.type === 'sentence_transformation') {
    return (
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
        <p className="font-medium text-lg text-gray-900 mb-2">{question.question}</p>
        {question.original && (
          <div className="bg-gray-50 p-4 rounded-lg mb-4 border border-gray-200">
            <p className="text-gray-800">{question.original}</p>
          </div>
        )}
        <input
          type="text"
          value={answer || ''}
          onChange={(e) => onAnswer(question.id, e.target.value)}
          placeholder="Wpisz przekształcone zdanie"
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>
    );
  }
  
  return null;
}
